import http from '@/vendor/axios'

export function addWeeklyComment (data) {
  const url = '/api/okr.weekly.comment'
  return http.post(url, {
    params: {
      data
    }
  })
}

export function getWeeklyComments (id) {
  const url = '/object/okr.weekly.comment/list'
  return http.post(url, {
    params: {
      kwargs: {
        weekly_id: id
      }
    }
  })
}

export function deleteWeeklyComments (id) {
  const url = `/object/okr.weekly.comment/${id}/archive`
  return http.post(url, {
    params: {
    }
  })
}

export function getOkrWeeklyList (okrId, startDate, endDate) {
  const url = '/object/okr.weekly/list'
  return http.post(url, {
    params: {
      kwargs: {
        okrlist_id: okrId,
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    }
  })
}

export function getOkrWeeklyListByOId (objectiveIds, startDate, endDate) {
  const url = '/object/okr.weekly/list'
  return http.post(url, {
    params: {
      kwargs: {
        objective_ids: objectiveIds,
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    }
  })
}

export function editOkrWeeklyList (data) {
  const url = '/object/okr.weekly/upsert_weekly'
  return http.post(url, {
    params: {
      kwargs: data
    }
  })
}

export function getOkrWeeklyRiskByOId (objectiveIds, startDate, endDate) {
  const url = '/object/okr.weekly.manager.risk/list'
  return http.post(url, {
    params: {
      kwargs: {
        objective_ids: objectiveIds,
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD')
      }
    }
  })
}

export function editOkrWeeklyRisk (data) {
  const url = '/object/okr.weekly.manager.risk/upsert_manager_risk'
  return http.post(url, {
    params: {
      kwargs: data
    }
  })
}

export function exportTeamWeekly (okrlistId, startDate, endDate) {
  const url = '/export/okr.weekly/list'
  return http.get(url, {
    params: {
      okrlist_id: okrlistId,
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD')
    }
  })
}
